import RangeGroup from './RangeGroup.jsx';
import SwitchButton from './SwitchButton.jsx';
import TextGroup from './TextGroup.jsx';
import PropTypes from 'prop-types';
import React from 'react';

const details = {
  propertyValue: {
    content: 'Property taxes are calculated from a home\'s value',
    href: '#info--propertyValue'
  },
  teacherPay: {
    content: 'A 1% increase costs the county $2.5 million',
    href: '#info--teacherPay'
  },
  artTeachers: {
    content: '10 additional teachers would put a full-time position at every elementary school',
    href: '#info--artTeachers'
  },
  instructionalSupport: {
    content: 'Includes additional instructors, social workers, and other personnel',
    href: '#info--instructionalSupport'
  },
  apCredits: {
    content: 'Funds post-secondary learning opportunities with goal of 5 post-secondary credits by graduation.',
    href: '#info--apCredits'
  },
  schoolMaintenance: {
    content: 'Fully funds school building maintenance',
    href: '#info--schoolMaintenance'
  }
};

class Control extends React.Component {
  constructor(props) {
    super(props);
    this.state = {ariaExpanded: false, drawerHidden: true};
    this.onDrawerToggle = this.onDrawerToggle.bind(this);
  }

  onDrawerToggle() {
    let {ariaExpanded, drawerHidden} = this.state;
    this.setState({ariaExpanded: !ariaExpanded, drawerHidden: !drawerHidden});
  }

  render() {
    const props = this.props;
    const {type} = this.props;
    const drawerID = `drawer-${this.props.id}`;
    const drawerDetails = details[this.props.name];
    const {ariaExpanded, drawerHidden} = this.state;
    const className = (type === 'switch') ? 'control--row' : 'control';
    let error = (props.error === undefined) ? {status: false, message: ''} : props.error;
    let Input, Label;

    switch(type) {
    case 'range':
      Input = <RangeGroup {... props} />;
      break;
    case 'switch':
      Input = <SwitchButton {... props} />;
      break;
    default:
      Input = <TextGroup {... props} />;
    }

    if (error.status) {
      Label = (
        <label className='control__label message--error' htmlFor={props.id}>
          <small role='alert'>Error: {error.message}</small><br />
          {props.label}
        </label>
      );
    } else {
      Label = <label className='control__label' htmlFor={props.id}>{props.label}</label>;
    }

    return (
      <div className={className}>
        {Label}
        {Input}
        <DrawerToggle ariaControls={drawerID} ariaExpanded={ariaExpanded} onClick={this.onDrawerToggle} />
        <Drawer id={drawerID} drawerHidden={drawerHidden} details={drawerDetails} />
      </div>
    );
  }
}

Control.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    status: PropTypes.bool
  }),
  id: PropTypes.string,
  name: PropTypes.string,
  symbol: PropTypes.string,
  type: PropTypes.string
};

const Drawer = props => {
  const {details, drawerHidden, id} = props;
  const {content, href} = details;
  const style = {lineHeight: 1.5};
  const innerHTML = (<div style={style}>{content}<br /><a href={href} data-scroll={true}>More</a></div>);

  return (
    <div className='control__drawer drawer' hidden={drawerHidden} id={id}>
      {innerHTML}
    </div>
  );
};

Drawer.propTypes = {
  details: PropTypes.shape({
    content: PropTypes.string,
    href: PropTypes.string
  }),
  drawerHidden: PropTypes.bool,
  id: PropTypes.string
};

const DrawerToggle = props => {
  const {ariaControls, ariaExpanded, ariaLabel, onClick} = props;
  return (
    <button
      aria-controls={ariaControls}
      aria-expanded={ariaExpanded}
      aria-label={ariaLabel || 'Toggle input details'}
      className='control__btn btn--toggle'
      onClick={onClick}
      type='button'
    >
      i
    </button>
  );
};

DrawerToggle.propTypes = {
  ariaControls: PropTypes.string,
  ariaExpanded: PropTypes.bool,
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func
};

export default Control;
